<template>
  <main>
    <banner :active.sync="isActive" :error="true" :title="error"></banner>
    <setting-template :title="this.$t('nav.settings')" :subtitle="this.$t('settings.account')">
      <template slot="left">
        <router-view></router-view>
      </template>
      <template slot="right">
        <ul class="list is-fixed">
<!--          <li class="list-item" ><router-link active-class="active" to="/settings/eos-account">EOS Account</router-link></li>-->
          <li class="list-item" ><router-link active-class="active" to="/settings/KYC">KYC</router-link></li>
          <li class="list-item has-bg-light p-16" ><button class="button is-primary is-fullwidth open_intercom">Contact Support</button></li>
        </ul>
      </template>
    </setting-template>
  </main>
</template>

<script>
import {mapState} from 'vuex'
import SettingTemplate from '@/templates/setting-template'
import ErrorBox from '@/components/general/error-box'
import Banner from '@/components/general/banner'

export default {
  data () {
    return {
      showRightNav: false
    }
  },
  components: {
    SettingTemplate,
    ErrorBox,
    Banner
  },
  computed: {
    ...mapState('sigproviders', [
      'error',
      'message'
    ]),
    isActive: {
      get () {
        return this.error !== null
      },
      set (value) {
        this.$store.commit('sigproviders/setError', null)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings.vue